/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REASSIGN_PROJECT_GROUP , REASSIGN_PROJECT_GROUP_RESPONSE } = constants.ReassignProjectGroupsConstants;


export default {
    REASSIGN_PROJECT_GROUP,
    REASSIGN_PROJECT_GROUP_RESPONSE,

  reassignProjectGroup: payload => ({
    type: REASSIGN_PROJECT_GROUP,
    payload
  }),
  reassignProjectGroupReceived: () => ({
    type: REASSIGN_PROJECT_GROUP_RESPONSE
  }),
};
